import { useQuery } from '@tanstack/react-query';
import { apiClient, type HealthStatus } from '@/services/apiClient';

const FALLBACK: HealthStatus = {
  status: 'down',
  database: 'unknown',
  objectStorage: 'unknown',
  uptime: 0,
  timestamp: new Date(0).toISOString(),
  reachable: false,
};

// Polls the API health endpoint. checkHealth() never throws, so `status` always
// resolves to structured data (a down/unreachable state when the API is offline).
export function useSystemStatus() {
  const query = useQuery({
    queryKey: ['system', 'health'],
    queryFn: () => apiClient.checkHealth(),
    refetchInterval: 30_000,
    staleTime: 15_000,
    retry: false,
  });

  return {
    ...query,
    status: query.data ?? FALLBACK,
  };
}
